/**
 * Naming the members and executions of an analysis group.
 *
 * It used to hold the vocabulary of upstream's older reading too — each member resolved to a run
 * of any execution, and the members with no result counted together «sin analizar, pero cuentan».
 * The product owner's rule (2026-09-24) retired that reading: a group is read by its latest
 * execution only, and `lib/latest-execution.ts` has the vocabulary for it.
 */

/** What a member is called when the server sent no name. */
export function memberLabel(member: {
  name?: string | null;
  sourceType?: string;
  sourceId?: string | number;
}): string {
  if (member?.name) return String(member.name);

  const noun = member?.sourceType === 'interview' ? 'Entrevista' : 'Vídeo';

  return `${noun} #${member?.sourceId ?? '?'}`;
}

/**
 * Default name of a group's batch, mirroring the server: `<grupo>@<yyyy-mm-dd HH:mm>`.
 *
 * Mirrored rather than requested because it is only a suggestion in a text field, and
 * a round trip to fill in a default nobody may keep is a round trip wasted. The server
 * applies its own if the field is left empty.
 */
export function defaultGroupBatch(groupName: string | null | undefined, date: Date): string {
  const pad = (value: number): string => String(value).padStart(2, '0');
  const stamp = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
    date.getHours(),
  )}:${pad(date.getMinutes())}`;

  return `${groupName || 'grupo'}@${stamp}`;
}
